var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { toMoney, toDateTime, toPorciento } from 'helpers/Format';
import TicketsReport from '../components/TicketsReport';
import history from '../../../helpers/History';
import { T } from '../../../helpers/i18n';
import { tramoHora } from './TicketSales';
var PacketSales = /** @class */ (function (_super) {
    __extends(PacketSales, _super);
    function PacketSales() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnSelectItem = function (item) {
            history.push("/packetsales/".concat(item.id), item);
        };
        return _this;
    }
    PacketSales.prototype.componentDidMount = function () {
        this.props.store.reports.readPacketickets();
    };
    PacketSales.prototype.render = function () {
        var reports = this.props.store.reports;
        var headers = [
            'businessUnit',
            'operationLine',
            'stretch',
            'numero',
            'user',
            'datecheck',
            'datevalited',
            'tramoHorario',
            'terminal',
            'netAmount',
            'discount',
            'taxAmount',
            'tipoPago',
            'total',
        ];
        var items = reports.packetTickets;
        // console.log('packets', reports.packetTickets)
        return (React.createElement(TicketsReport, { onSelectItem: this.handleOnSelectItem, search: true, header: headers, items: items, 
            /*total={(tickets: Ticket[]) =>
              tickets.reduce((sum, item) => item.total + sum, 0)}*/
            total: function (tickets) {
                return tickets.reduce(function (sum, item) {
                    if (item.daterefund)
                        return sum;
                    return item.total + sum;
                }, 0);
            }, loading: !reports.packetTicketsLoaded, 
            // cambio a '(ticket: Ticket) => String(ticket.numero)' porque en paquetes hay paquetes, paquetes en colaboración, ...
            // y puede estar repetido el id
            keyExtractor: function (ticket) { return String(ticket.numero); }, format: function (tickets) {
                return tickets.map(function (ticket) { return (__assign(__assign({}, ticket), { businessUnit: ticket.businessUnit, operationLine: ticket.operationLine, stretch: ticket.stretch, datecheck: toDateTime(ticket.datecheck), datevalited: !ticket.daterefund ? ticket.datevalited ? toDateTime(ticket.datevalited) : 'sin validar' : T('canceled'), discount: toPorciento(ticket.discount), tramoHorario: ticket.tramoHora ? tramoHora(ticket.datebook, ticket.hours, ticket.minutes) : 'NO', netAmount: toMoney(ticket.netAmount, ticket.money), taxAmount: toMoney(ticket.taxAmount, ticket.money), 
                    /*taxBase: toMoney(ticket.taxBase),*/
                    total: toMoney(ticket.total, ticket.money), 
                    // user: ticket.user// this.findUser(this.props.store!.users.users, ticket.user_id)
                    /*user: this.findUser(this.props.store!.users.users, ticket.user_id)*/
                    user: ticket.username, tipoPago: T(ticket.tipoPago) })); });
            } }));
    };
    PacketSales = __decorate([
        inject('store'),
        observer
    ], PacketSales);
    return PacketSales;
}(Component));
export default PacketSales;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/PacketSales.tsx
// module id = 1151
// module chunks = 0